import React, { Component } from 'react'
import Radium from 'radium'
import { Table, Badge } from 'reactstrap'

import SearchBar from './SearchBar'
import XofY from './XofY'
import GenModal from './GenModal'
import SaveModal from './SaveModal'
import unchecked from '../images/unchecked.png'
import checked from '../images/checked.png'
import PillTip from './PillTip'

function browserID () {
  const sUsrAg = navigator.userAgent
  if (sUsrAg.indexOf("Firefox") > -1) {
    return 'firefox'
  } else if (sUsrAg.indexOf("SamsungBrowser") > -1) {
    return 'samsung'
  } else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
    return 'opera'
  } else if (sUsrAg.indexOf("Trident") > -1) {
    return 'trident'
  } else if (sUsrAg.indexOf("Edge") > -1) {
    return 'edge'
  } else if (sUsrAg.indexOf("Chrome") > -1) {
    return 'chrome'
  } else if (sUsrAg.indexOf("Safari") > -1) {
    return 'safari'
  } else {
    return 'unknown'
  }
}


class ElectionList extends Component {

  state = {
    filter: '',
    choices: [],
    colors: [ "primary", "success", "danger", "warning", "info" ]
  }

  setFilter = (filter) => { this.setState({ filter: filter }) }

  setCallback = (object) => {
    this.props.callbackFromParent(object)
  }

  backButton = () => {
    return true
  }

  showRow = (name, filter) => {
    if (filter.length === 0) {
      return true
    } else {
      name = name.toLowerCase()
      filter = filter.toLowerCase()
      return name.includes(filter)
    }
  }

  checkOrUnchecked = (selected) => {
    if(selected) {
      this.props.initChoice()
      return (
        <img src={checked} alt="selected" width="auto" height="32px"/>
      )
    } else {
      return (
        <img src={unchecked} alt="unselected" width="auto" height="32px"/>
      )
    }
  }

  leavePill = (leaveNumber) => {
    let candidatesLeave = {}
    this.props.leave.forEach(number => {
      if (leaveNumber === number.order) {
        candidatesLeave = number
      }
    })
    if (candidatesLeave !== {}) {
      return (
        <>
          <Badge color={this.state.colors[leaveNumber - 1]} pill id={'leave' + leaveNumber}>{leaveNumber}</Badge>
          <PillTip
            target={'leave' + leaveNumber}
            message={candidatesLeave.leave}
          />
        </>
      )
    } else {
      return null
    }
  }

  divisionFormat = (division) => {
    if(division.length === 1) {
      return (
        <>Division: {division}</>
      )
    } else {
      return (
        <>{division}</>
      )
    }
  }

  checkNumChoices = () => {
    if (this.props.list.number_selected > this.props.list.number_to_select) {
      return false
    } else {
      return true
    }
  }

  getSelectedNames = () => {
    const Names = this.props.choices.map((candidate, index) => {
      return (
        <li key={index}>{candidate.name}</li>
      )
    })
    return Names
  }

  generateBody = () => {
    if (this.props.choices.length > 0) {
      return (
        <>
        <p>You have selected: </p>
        <ul style={{marginLeft: '8px'}}>{this.getSelectedNames()}</ul>
        <p>Is this correct?</p>
        </>
      )
    } else {
      return (
        <>
        <p>You have selected to abstain from this division. Is this correct?</p>
        </>
      )
    }
  }

  generateList = () => {
    if (!(this.props.list.candidates === undefined)) {
      const List = this.props.list.candidates.map((candidate, index) => {
        const tableRowStyle = {
          display: this.showRow(candidate.name, this.state.filter)? 'flex' : 'none',
          flexDirection: 'row',
          justifyContent: 'space-between',
          cursor: 'pointer',
          background: candidate.selected? '#d7c3e8' : '',
        }
        return (
          <tr style={tableRowStyle} key={index} onClick={this.props.markChoice.bind(this, candidate.id)}>
            <td style={tableDataStyle}>{candidate.name}{' '}{this.leavePill(candidate.leave)}</td>
            <td style={iconStyle}>{this.checkOrUnchecked(candidate.selected)}</td>
          </tr>
        )
      })
      return List
    }
    return null
  }

  componentDidMount () {
    window.scrollTo(0,0)
  }

  render () {
    if (this.props.list.type === 'nomination') {
      return (
        <div style={boxStyle}>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
            <h2 style={titleStyle}>{this.props.title}</h2>
            <h3 style={subtitleStyle}>{this.divisionFormat(this.props.divTitle)}</h3>
          </div>
          <div style={searchAndXofYStyle}>
            <SearchBar callbackFromParent={this.setFilter}/>
            <XofY x={this.props.list.number_selected} y={this.props.list.number_to_select} />
          </div>
          <Table style={{marginBottom: '0'}} striped>
            <tbody style={tableBodyStyle}>
              {this.generateList()}
            </tbody>
          </Table>
          <div style={buttonRowStyle}>
            <GenModal
              buttonLabel='CANCEL'
              buttonClass='btn-secondary'
              title='Confirmation'
              body='Are you sure you would like to cancel? Choices made will not be saved.'
              yesPath='/status'
              yesFunc={this.backButton}
            />
            <SaveModal
              title='Confirmation'
              body={this.generateBody()}
              yesPath='/status'
              yesFunc={this.props.saveChoices}
              allowed={this.checkNumChoices()}
            />
          </div>
        </div>
      )
    } else {
      return (
        <div style={boxStyle}>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
            <h2 style={titleStyle}>{this.props.title}</h2>
            <h3 style={subtitleStyle}>{this.divisionFormat(this.props.divTitle)}</h3>
          </div>
          <div style={searchAndXofYStyle}>
            <XofY x={this.props.list.number_selected} y={this.props.list.number_to_select} />
          </div>
          <Table style={{marginBottom: '0'}} striped>
            <tbody style={tableBodyStyle}>
                {this.generateList()}
            </tbody>
          </Table>
          <div style={buttonRowStyle}>
            <GenModal
              buttonLabel='CANCEL'
              buttonClass='btn-secondary'
              title='Confirmation'
              body='Are you sure you would like to cancel? Choices made will not be saved.'
              yesPath='/status'
              yesFunc={this.backButton}
            />
            <SaveModal
              title='Confirmation'
              body={this.generateBody()}
              yesPath='/status'
              yesFunc={this.props.saveChoices}
              allowed={this.checkNumChoices()}
            />
          </div>
        </div>
      )
    }
  }
}

const boxStyle = {
  width: 'auto',
  height: 'auto',
  display: 'flex',
  flexDirection: 'column',
  border: '2px solid #000000',
  borderRadius: '8px',
  boxShadow: '0px 20px 40px rgba(0, 0, 0, 0.15)',
  background: '#602d89',
  '@media (max-width: 420px)': {
    marginTop: '0px'
  },
  '@media (min-width: 421px)': {
    marginTop: '2rem'
  },
  marginBottom: '4rem',
}

const titleStyle = {
  color: '#fff',
  padding: '20px 5px 5px 8px',
  fontFamily: 'Avenir',
  lineHeight: '1.4',
  '@media (max-width: 420px)': {
    fontSize: '20px'
  },
  '@media (min-width: 421px)': {
    fontSize: '24px',
  },
}

const subtitleStyle = {
  color: '#fff',
  padding: '20px 8px 5px 8px',
  fontFamily: 'Avenir',
  lineHeight: '1.4',
  '@media (max-width: 420px)': {
    fontSize: '20px'
  },
  '@media (min-width: 421px)': {
    fontSize: '24px',
  },
}

const tableBodyStyle = {
  display: 'flex',
  flexDirection: 'column',
  maxHeight: ((browserID() === 'safari') || (browserID() === 'samsung')) ? 'none' : '352px',
  overflowY: 'scroll',
  background: '#ffffff',
}

const tableDataStyle = {
  padding: '10px 0px 0px 8px',
  textAlign: 'left',
  fontFamily: 'Avenir',
}

const iconStyle = {
  padding: '4px 8px 4px 0px',
  textAlign: 'center',
}

const buttonRowStyle = {
  padding: '10px 20px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between'
}

const searchAndXofYStyle = {
  display: 'flex',
  '@media (max-width: 420px)': {
    flexDirection: 'column',
    padding: '0px 8px'
  },
  '@media (min-width: 421px)': {
    padding: '10px 8px',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  background: '#333333'
}

export default Radium(ElectionList)
